module.exports = __webpack_public_path__ + "media/images/dummy/about-635e38c9aa87349ef7f11f6765bf121b.png";